export default __webpack_public_path__ + "static/media/lemontbotanique_l3.11943851.png";